import {
  Box,
  Button,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../utils/constants';
import { trainingRoleLabel } from '../../utils/trainingAccess';

function cardCopy(summary, rolePath) {
  const totalModules = summary?.totalModules || 0;
  const completedModules = summary?.completedModules || 0;
  const hasStarted = summary?.hasStarted;
  const allComplete = summary?.allComplete;

  if (allComplete && totalModules > 0) {
    return {
      headline: 'Training path complete',
      subline: `You finished all ${totalModules} modules in your ${trainingRoleLabel(rolePath)} path.`,
      cta: 'Review Training',
    };
  }
  if (hasStarted) {
    return {
      headline: 'Continue your Signal Bridge training',
      subline: `${completedModules} of ${totalModules} modules complete`,
      cta: 'Continue Training',
    };
  }
  return {
    headline: 'Start your Signal Bridge training',
    subline: `Your ${trainingRoleLabel(rolePath)} path contains ${totalModules} modules.`,
    cta: 'Start Training',
  };
}

export default function TrainingDashboardCard({ curriculum, loading }) {
  const navigate = useNavigate();
  const summary = curriculum?.summary || {};
  const copy = cardCopy(summary, curriculum?.rolePath);

  if (loading) {
    return (
      <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }} data-testid="dashboard-training-card">
        <Typography variant="body2" color="text.secondary">Loading training progress…</Typography>
      </Paper>
    );
  }

  if (!curriculum?.modules?.length) {
    return null;
  }

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        borderRadius: 2,
        bgcolor: '#ffffff',
        borderColor: 'rgba(15,23,42,0.12)',
        boxShadow: '0 2px 8px rgba(15, 23, 42, 0.08)',
        cursor: 'pointer',
      }}
      data-testid="dashboard-training-card"
      onClick={() => navigate(ROUTES.TRAINING)}
    >
      <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
        <Stack direction="row" spacing={1.5} alignItems="flex-start">
          <Box sx={{ color: 'primary.main', pt: 0.25 }}>
            <SchoolIcon />
          </Box>
          <Box>
            <Typography variant="overline" color="primary.main" sx={{ lineHeight: 1.2 }}>
              Training
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.25 }}>
              {copy.headline}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              {copy.subline}
            </Typography>
          </Box>
        </Stack>
        <Button
          variant="contained"
          size="small"
          data-testid="dashboard-training-cta"
          onClick={(e) => {
            e.stopPropagation();
            navigate(ROUTES.TRAINING);
          }}
        >
          {copy.cta}
        </Button>
      </Stack>
    </Paper>
  );
}
